import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="row gy-4">
            
            <div className="col-lg-5 col-md-12 footer-info">
              <Link to="/" className="logo d-flex align-items-center">
                <img src="/assets/img/PerfectSignsLogoFinalFooter.jpg" alt="Perfect Signs Canada logo" />
                <span>PERFECT SIGNS</span>
              </Link>
              <p>
                We help businesses stand out with custom signage, professional websites, digital marketing, and practical technology support. From first concept to final delivery, our goal is simple: make your brand easier to notice and easier to trust.
              </p>
              <div className="social-links d-flex mt-3">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="twitter"><i className="bi bi-twitter"></i></a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="facebook"><i className="bi bi-facebook"></i></a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="instagram"><i className="bi bi-instagram"></i></a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="linkedin"><i className="bi bi-linkedin"></i></a>
              </div>
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li><i className="bi bi-dash"></i> <Link to="/">Home</Link></li>
                <li><i className="bi bi-dash"></i> <Link to="/about">About us</Link></li>
                <li><i class="bi bi-dash"></i> <Link to="/services">IT Services</Link></li>
                <li><i class="bi bi-dash"></i> <Link to="/signage">Signage</Link></li>
                <li><i className="bi bi-dash"></i> <Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="col-lg-2 col-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li><i className="bi bi-dash"></i> <Link to="/signage">Custom Signage</Link></li>
                <li><i className="bi bi-dash"></i> <Link to="/signage">Vehicle Wraps</Link></li>
                <li><i className="bi bi-dash"></i> <Link to="/services">Web Design</Link></li>
                <li><i className="bi bi-dash"></i> <Link to="/marketing">Marketing</Link></li>
                <li><i className="bi bi-dash"></i> <Link to="/services">POS Support</Link></li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
              <h4>Contact Us</h4>
              <p>
                6109 176 Ave NW <br />
                Edmonton, AB T5Y 0K8<br />
                CANADA <br /><br />
                <strong>Phone:</strong> <a href="tel:+17805543949" style={{ color: 'inherit' }}>+1 780-554-3949</a><br />
                <strong>Email:</strong> <a href="mailto:info@perfectsignscanada.com" style={{ color: 'inherit' }}>info@perfectsignscanada.com</a><br />
              </p>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-legal">
        <div className="container">
          <div className="copyright">
            &copy; Copyright {currentYear} <strong><span>PERFECT SIGNS</span></strong>. All Rights Reserved
          </div>
          <div className="credits">
            Designed by <Link to="/">PERFECT SIGNS</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
